import { AccessUserData } from '../../Models/Classes/User/access-user-data';
import { Utils } from '../../Models/Classes/utils';
import { Injectable } from '@angular/core';
import { HTTP } from '@ionic-native/http/ngx';
import { RequestResponse } from 'src/app/Models/Classes/request-response';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import Swal2 from 'sweetalert2';
/*
import { AuthService } from 'src/app/services/auth/auth.service';
import { ChatService } from 'src/app/services/chat/chat.service';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import {  NavController } from '@ionic/angular';*/
//import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
@Injectable({
	providedIn: 'root'
})
export class RequestService {
	//private AUTH_SERVER_ADDRESS = 'http://127.0.0.1:8000/api/';
	//  private AUTH_SERVER_ADDRESS = 'http://18.119.70.56/api/';
	//private AUTH_SERVER_ADDRESS = 'http://192.168.100.249:8000/api/';
	//private AUTH_SERVER_ADDRESS = 'http://192.168.100.21:8000/api/';
	//private AUTH_SERVER_ADDRESS = 'http://192.168.0.8:8000/api/';

	// private AUTH_SERVER_ADDRESS = 'http://192.168.1.66:8000/api/';
  	//private AUTH_SERVER_ADDRESS = 'http://192.168.1.82:8000/api/';
	//private AUTH_SERVER_ADDRESS = 'https://9jkrdd2hdl.execute-api.us-east-1.amazonaws.com/api/';
	private AUTH_SERVER_ADDRESS = 'https://supercluster-api.laniakea.tv/api/';





	

	//private AUTH_SERVER_ADDRESS = 'https://01jia6a6e9.execute-api.us-east-1.amazonaws.com/api/';


	private HEADERS = { 'Content-Type': 'application/json', 'Authorization': '', 'Access-Control-Allow-Origin': '*' };
	private readonly shortCacheMs = 45000;
	private readonly shortCache = new Map<string, { expiresAt: number; value: any }>();
	private readonly cacheableGetEndpoints = new Set<string>([
		'loyalty-cards',
		'publications',
		'profile',
		'search',
		'Hubble',
	]);
	private readonly cacheablePostEndpoints = new Set<string>([
		'getAlibabaProducts',
		'get_ds_margin_param',
		'walmartAffiliateSearchDemo',
		'spotify_search',
		'get_AI_Videos_and_images',
	]);

	// Endpoint registration is ordered and must be declared in BOTH places:
	// append new entries at the bottom of END_POINTS, then append the matching
	// case at the bottom of selectEnpoint(), using the same zero-based index.
	// Never insert entries in the middle, reorder existing entries, or return
	// an inline endpoint array from a case: that breaks the shared index order.
	private END_POINTS = [
		['login', '0'],
		['register', '0'],
		['logout', '1'],
		['publications', '1'],
		['profile', '1'],
		['relations', '1'],
		['products', '1'],
		['comments', '1'],
		['getStatuses', '1'],
		['chatElement', '1'],
		['getCorpPublications', '1'],
		['getVersion', '1'],
		['notifications', '1'],
		['payments/newPayment', '1'],
		['payments/transactions', '1'],
		['productCategories', '1'],
		['search', '1'],
		['users', '1'],
		['user/publications/newPublication', '1'],
		['payments/getCurrencyValue', '1'],
		['publications.multimedia', '1'],
		['s3_form', '1'],
		['profileMultimedia', '1'],
		['fakerpay','1'],
		['fakerpay/getID','1'],
    ['comments.multimedia','1'],
    ['filterAll','1'],
    ['stripe-pay','1'],
    ['profile/update_reconoserid','1'],
    ['save_publication','1'],
    ['delete_save_publication','1'],
    ['publications_saved','1'],
	['profile-all', '1'],
	['categories', '1'],
	['regalos', '1'],
	['contador-regalos', '1'],
	['show_regalos', '1'],
	['send-email-retiros', '1'],
	['Onboard', '1'],
	['CheckConnectStatus', '1'],
	['incrementViews', '0'],
	['showViews', '1'],
	['send-email', '1'],
	['verified-confirmation', '1'],
	['UsuarioVerificado', '1'],
	['Deposit', '1'],
	['Hubble', '1'],
	['Conversiones', '1'],
	['saveAIData', '1'],
	['getAIData', '1'],
	['publications_gifted', '1'],
	['publications_paid', '1'],
	['MiMonedaDeRegalos', '1'],
	['VerMiMonedaDeRegalos', '1'],
	['publications_AI', '0'],
	['PagoDePublicaciones', '1'],
	['IN-APP-PURCHASE-1', '1'],
	['RegalosNotifications', '1'],
	['VentasNotifications', '1'],
	['CountersFachada', '1'],
	['Payout', '1'],
	['PayStripeURL', '1'],
	['getExchangeValue', '1'],
	['exchangeAssets', '1'],
	['IN-APP-PURCHASE-2', '1'],
	['StripeIdentified', '1'],
	['publications_UL', '0'],
	['publications_Profiles', '1'],
	['GreatAtractorNotifications', '1'],
	['saveDeviceToken', '1'],
	['saveWebPageAndDescription', '1'],
	['reset-password', '0'],
	['send-email-to-reset-password', '0'],
	['DeletePublication', '1'],
	['AugmentShareCounter', '1'],
	['AugmentSaveCounter', '1'],
	['FGA2FA', '0'],
	['verified-confirmation-password', '0'],
	['modifyUsernameAndEmail', '1'],
	['GetSuperclusterMap', '1'],
	['CupoDisponible', '1'],
	['categoriesEpoch', '1'],
	['categoriesEclipse', '1'],
	['categoriesLand', '1'],
	['categoriesEarth', '1'],
	['PagoDePublicacionesCalendario', '1'],
	['ValorarPublicaciones', '1'],
	['collectionOfReservations', '1'],
	['scanReservations', '1'],
	['CupoDisponibleEarth', '1'],
	['createChatRequest', '0'],
	['updateChatRequest', '1'],
	['live_stream_regalos', '1'],
	['UpdateDiamonds', '1'],
	['ProliferarPublicacion', '1'],
	['GenaralNotificationsCounter', '1'],
	['UpdateNotificationRecord', '1'],
	['LaniakeaConversation', '1'],
	['validateThatTheUserIsUnblockedInMessage', '1'],
	['toggleBlockStatus', '1'],
	['myVehiclesData', '1'],
	['arrendadorBuscaViajes', '1'],
	['clientRequestsShootingStarsTrip', '1'],
	['getShootingStarsOrders', '1'],
	['openPayDeposit', '1'],
	['openPayPayout', '1'],
	['HubbleToHubbleTransfer', '1'],
	['SMSCodeVerification', '0'],
	['ModifyPhoneNumber', '1'],
	['EliminarCuenta', '1'],
	['reviewAndRateShootingStarsTrip', '1'],
	['sendPragmaticCorporateMail', '1'],
	['VehicleCoordinates', '1'],
	['YourArtificialVoices', '1'],
	['Register_with_BBVA_account', '0'],
	['AuthSMSCodeVerification', '1'],
	['create_BBVA_ACCOUNT', '1'],
	['bindPhysicalCardToBBVA_account', '1'],
	['certifyMercado', '0'],
	['fetchBBVA_account_data', '1'],
	['requestMortgage', '1'],
	['requestAutomobileLoan', '1'],
	['requestBBVA_ATM_or_branches_locations', '1'],
	['PostingEntrelazamientoContent', '1'],
	['EntanglementInteraction', '1'],
	['createAWSTranscribe', '1'],
	['ProtoInternetData', '0'],
	['Historic_calls', '1'],
	['getHistoric_AI_CHAT', '1'],
	['redirectToInstagramForThirdPartyEntanglement', '1'],
	['postToInstagram', '1'],
	['redirectToXForPostsEntanglement', '1'],
	['handleUserIDInstagramCallback', '0'],
	['getting_TP_POSTS', '1'],
	['uploadThirdPartyMedia', '1'],
	['redirectToLinkedInForEntanglement', '1'],
	['redirectToTikTokForEntanglement', '1'],
	['redirectToYoutubeEntanglement', '1'],
	['postMediaToLinkedIn', '1'],
	['postMediaToX', '1'],
	['checkTikTokPostStatus', '1'],
	['getAuthTikTokProfile', '1'],
	['getAuthInstagramProfile', '1'],
	['getAuthLinkedInProfile', '1'],
	['getAuthXProfile', '1'],
	['postToTikTok', '1'],
	['get_BBVA_Locations', '1'],
	['getProfileByUser_Id', '1'],
	['getTTSAIAvatar', '1'],
	['getAuthWixProfile', '1'],
	['postUserObservations', '1'],
	['save_content_preferences_component', '1'],
	['graphUser', '1'],
	['getConversationTagsForAuthenticatedUser', '1'],
	['toggleConversationTags', '1'],
	['get_stories_by_user', '1'],
	['voice_note_instance', '1'],
	['enterToWalletWithPIN', '1'],
	['getAuthYouTubeToken', '1'],
	['VerificationWithOpenPay', '1'],
	['playlist_controller', '1'],
	['publications_from_playlist', '1'],
	['handle_hey_Lia', '1'],
	['insert_face_identifaction', '1'],
	['handleShippingWithAmazon', '1'],
	['requestAnUberRide', '1'],
	['handleShipping', '1'],
	['get_face_identifaction', '0'],
	['redirectToAmazonLoginForShipping', '0'],
	['createWireTransfer', '1'],
	['smsMesagesHandler', '1'],
	['WhatsappMesagesHandler', '1'],
	['postToThreadsProfile', '1'],
	['redirectToThreadsLoginForEntanglement', '1'],
	['redirectToThreadsLoginForGettingThreads', '1'],
	['profile_facade_sections_controller', '1'],
	['ShippingAddressesController', '1'],
	['getTextAutocomplePredictionGenerativePretrainingTransformer', '1'],
	['getAlibabaProducts', '0'],
	['AlibabaProductHandler', '0'],
	['ControladorDeCarritoDeCompras', '1'],
	['GetAuthUser', '1'],
	['PersistentLiveStreamIPTVController', '1'],
	['UnAuthStripe', '0'],
	['getRecordByToken', '0'],
	['sendPragmaticCorporateMailUnAuth', '0'],
	['crypto_pal_unauth', '0'],
	['openPayDeposit_unauth', '0'],
	['getCurrencyValue_unauth', '0'],
	['getLatestIOS_version', '0'],
	['creatApplePayIntent', '0'],
	['redirectToUberEntanglement', '0'],
	['add_products_to_wishlist', '1'],
	['sendFirebaseCM', '1'],
	['requestCentralizedFreightUnAuth', '0'],
	['make_a_guesty_request', '0'],
    ['SumMexicoKYC_url', '1'],
	['tmFetchEvents', '0'],
	['walmartAffiliateSearchDemo', '0'],
	['Auth_Stripe_Alibaba', '1'],
	['save_card_for_stripe_payment', '1'],
	['get_stripe_default_saved_payment_method', '1'],
	['chargeSavedStripeCard', '1'],
	['AliPayChargeSavedStripeCard', '1'],
	['spotify_search', '0'],
	['spotify_search_auth', '1'],
	['get_ds_margin_param', '0'],
    ['search_page_unauth', '0'],
	['issue_individual_debit_card', '0'],
	['converse_bedrock', '0'],
	['createChatRequest_unauth', '0'],
	['get_video_gen_stat', '0'],
    ['updateChatRequest_unauth', '0'],
	['get_AI_Videos_and_images', '0'],
	['make_a_bbva_api_channel_business_payment', '1'],
	['make_a_bbva_api_channel_business_payment_unauth', '0'],
	['get_saved_accounts', '1'],
	['update_sumamexico_veridocid_auth', '1'],
	['YourArtificialVoicesPublic', '0'],

	// === Agent / MCP Authorization endpoints ===
	['agent-access-requests', '1'],
	['get_my_authenticated_mcps', '1'],
	['authorized-agents', '1'],
	['createOxxoIntent', '1'],
	['confirmAlibabaApplePay', '1'],
	['postMediaToFacebook', '1'],
	['getAuthFacebookProfile', '1'],
	['welcomeKycAutosave', '1'],
	['redirectToFacebookForPostsEntanglement', '1'],
	['loyalty-cards', '1'],
	['publications_AI_auth', '1'],
	['publications/seen', '1'],
	['apple-tv/pairing-sessions', '1'],
	['video-enhancements', '1'],
	['contacts/matches', '1'],
	['openpay-payouts', '1'],
	['profile_music_playlist', '0'],
	['profile_music_playlist_auth', '1'],
	['profile-games', '1'],
	['profiles', '1'],
	['welcomeFoundingFriends', '1'],
	['welcomeSubscription', '1'],
	['passkeys/authentication/options', '0'],
	['passkeys/authentication/verify', '0'],
	['passkeys/registration/options', '1'],
	['passkeys/registration/verify', '1'],
	['auth/account-lookup', '0'],
	['lia-collabs', '1'],
	['admin/featured-profile-photos', '1'],
	['profile/public-discovery-location', '1'],
	['wix/laniakea/jarvis/publish', '1'],
	['shazam/history', '1'],
	// Android requests a short-lived, server-signed catalog token before a
	// native session may have been restored. It carries no user data.
	['shazam/token', '0'],
		['weather/context', '1'],
		['hubble/nearby/sessions', '1'],
		['hubble/nearby/resolve', '1'],
		['stripe/terminal/config', '1'],
		['stripe/terminal/feex-payment-intent', '1'],
		['stripe/terminal/confirm-feex-payment', '1'],
		['stripe/terminal/receipt', '1'],
		['mycelium/feed', '0'],
		['mycelium/text-posts', '1'],
		['mycelium/feed/auth', '1'],
		['mycelium/comments/view', '0'],
		['mycelium/comments/repost', '1'],
		['mycelium/comments/save', '1'],
		['mycelium/comments/saved', '1'],
		['mycelium/comments/reposted', '1'],
		['mycelium/comments/seen', '1'],
		['EmailCodeVerification', '0'],
		['mycelium/jarvis/mention', '1'],
		['wan-animations', '1'],
		['admin/jarvis-email-threads', '1'],
		['getOpenPaySubscriptionByUser', '1'],
		['jubilados-bbva/cases', '0'],
		['publications/not-interested', '1'],
		['jubilados-bbva/register', '0'],
		['iosCall', '1'], // Index 276; matching case is at the bottom of selectEnpoint().
		['call-invitations', '1'], // Index 277; matching case is at the bottom of selectEnpoint().
		['scheduled-calls', '1'], // Index 278; keep this in sync with selectEnpoint().
		
	];
	constructor(
		//private http2: HttpClient,
		private utils: Utils,
		private http: HTTP,
		private router:Router,
		//private navCtrl: NavController,
		//private authService: AuthService,
		//private nativeStorage: NativeStorage,
		//private chatService: ChatService,
	) { }

	// Keep endpoint cases in the same order as END_POINTS. Every new endpoint
	// must be appended to BOTH lists, with its actual END_POINTS array index.
	private selectEnpoint(endPoint: string): Array<string> {
		switch (endPoint) {
			case 'login':
				return this.END_POINTS[0];
			case 'register':
				return this.END_POINTS[1];
			case 'logout':
				return this.END_POINTS[2];
			case 'publications':
				return this.END_POINTS[3];
			case 'profile':
				return this.END_POINTS[4];
			case 'relations':
				return this.END_POINTS[5];
			case 'products':
				return this.END_POINTS[6];
			case 'comments':
				return this.END_POINTS[7];
			case 'stories':
				return this.END_POINTS[8];
			case 'chatElement':
				return this.END_POINTS[9];
			case 'getCorpPublications':
				return this.END_POINTS[10];
			case 'getVersion':
				return this.END_POINTS[11];
			case 'notifications':
				return this.END_POINTS[12];
			case 'payment':
				return this.END_POINTS[13];
			case 'transactions':
				return this.END_POINTS[14];
			case 'productCategories':
				return this.END_POINTS[15];
			case 'search':
				return this.END_POINTS[16];
			case 'users':
				return this.END_POINTS[17];
			case 'newPublication':
				return this.END_POINTS[18];
			case 'getCurrencyValue':
				return this.END_POINTS[19];
			case 'publications.multimedia':
				return this.END_POINTS[20];
			case 's3_form':
				return this.END_POINTS[21];
			case 'profileMultimedia':
				return this.END_POINTS[22];
			case 'fakerpay':
				return this.END_POINTS[23];
			case 'fakerpay/getID':
				return this.END_POINTS[24];
            case 'comments.multimedia':
                return this.END_POINTS[25];
			case 'publications/filterAll':
				return this.END_POINTS[26];
      case 'stripe-pay':
        return this.END_POINTS[27];
      case 'profile/update_reconoserid':
        return this.END_POINTS[28];
      case 'save_publication':
        return this.END_POINTS[29];
      case 'delete_save_publication':
        return this.END_POINTS[30];
      case 'publications_saved':
        return this.END_POINTS[31];
	  case 'profile-all':
	    return this.END_POINTS[32];
	  case 'categories':
		console.log(this.END_POINTS[33]);
		return this.END_POINTS[33];
	  case 'regalos':
		return this.END_POINTS[34]
	  case 'contador-regalos':
		return this.END_POINTS[35]
	  case 'show_regalos':
		return this.END_POINTS[36];
	  case 'send-email-retiros':
		  return this.END_POINTS[37];
	  case 'Onboard':
		  return this.END_POINTS[38];
	  case 'CheckConnectStatus':
		  return this.END_POINTS[39];
	  case 'incrementViews':
		  return this.END_POINTS[40];
	  case 'showViews':
		  return this.END_POINTS[41];
	  case 'send-email':
		  return this.END_POINTS[42];
	  case 'verified-confirmation':
		  return this.END_POINTS[43];
	  case 'UsuarioVerificado':
		  return this.END_POINTS[44];
	  case 'Deposit':
		  return this.END_POINTS[45];
	  case 'Hubble':
		  return this.END_POINTS[46];
	  case 'Conversiones':
		  return this.END_POINTS[47];
	  case 'saveAIData':
		  return this.END_POINTS[48];
	  case 'getAIData':
		  return this.END_POINTS[49];
	  case 'publications_gifted':
		  return this.END_POINTS[50];
	  case 'publications_paid':
		  return this.END_POINTS[51];
	  case 'MiMonedaDeRegalos':
		  return this.END_POINTS[52];
	  case 'VerMiMonedaDeRegalos':
		  return this.END_POINTS[53];
	  case 'publications_AI':
		  return this.END_POINTS[54];
	  case 'PagoDePublicaciones':
		  return this.END_POINTS[55];
	  case 'IN-APP-PURCHASE-1':
		  return this.END_POINTS[56];
	  case 'RegalosNotifications':
		  return this.END_POINTS[57];
	  case 'VentasNotifications':
		  return this.END_POINTS[58];
	  case 'CountersFachada':
		  return this.END_POINTS[59];
	  case 'Payout':
		  return this.END_POINTS[60];
	  case 'PayStripeURL':
		  return this.END_POINTS[61];
	  case 'getExchangeValue':
		  return this.END_POINTS[62];
	  case 'exchangeAssets':
		  return this.END_POINTS[63];
	  case 'IN-APP-PURCHASE-2':
		  return this.END_POINTS[64];
	  case 'StripeIdentified':
		  return this.END_POINTS[65];
	  case 'publications_UL':
		  return this.END_POINTS[66];
	  case 'publications_Profiles':
		  return this.END_POINTS[67];
	  case 'GreatAtractorNotifications':
		  return this.END_POINTS[68];
	  case 'saveDeviceToken':
		  return this.END_POINTS[69];
	  case 'saveWebPageAndDescription':
		  return this.END_POINTS[70];
	  case 'reset-password':
		  return this.END_POINTS[71];
	  case 'send-email-to-reset-password':
		  return this.END_POINTS[72];
	  case 'DeletePublication':
		  return this.END_POINTS[73];
	  case 'AugmentShareCounter':
		  return this.END_POINTS[74];
	  case 'AugmentSaveCounter':
		  return this.END_POINTS[75];
	  case 'FGA2FA':
		  return this.END_POINTS[76];
	  case 'verified-confirmation-password':
		  return this.END_POINTS[77];
	  case 'modifyUsernameAndEmail':
		  return this.END_POINTS[78];
	  case 'GetSuperclusterMap':
		  return this.END_POINTS[79];
	  case 'CupoDisponible':
		  return this.END_POINTS[80];
	  case 'categoriesEpoch':
		  return this.END_POINTS[81];
	  case 'categoriesEclipse':
		   return this.END_POINTS[82];
	  case 'categoriesLand':
		   return this.END_POINTS[83];
	  case 'categoriesEarth':
	       return this.END_POINTS[84];
	  case 'PagoDePublicacionesCalendario':
		   return this.END_POINTS[85];
	  case 'ValorarPublicaciones':
		   return this.END_POINTS[86];
	  case 'collectionOfReservations':
		   return this.END_POINTS[87];
	  case 'scanReservations':
		   return this.END_POINTS[88];
	  case 'CupoDisponibleEarth':
		   return this.END_POINTS[89];
case 'createChatRequest':
return this.END_POINTS[90];
case 'updateChatRequest':
return this.END_POINTS[91];
case 'live_stream_regalos':
return this.END_POINTS[92];
case 'UpdateDiamonds':
return this.END_POINTS[93];
case 'ProliferarPublicacion':
return this.END_POINTS[94];
case 'GenaralNotificationsCounter':
return this.END_POINTS[95];
case 'UpdateNotificationRecord':
return this.END_POINTS[96];
case 'LaniakeaConversation':
return this.END_POINTS[97];
case 'validateThatTheUserIsUnblockedInMessage':
return this.END_POINTS[98];
case 'toggleBlockStatus':
return this.END_POINTS[99];
case 'myVehiclesData':
return this.END_POINTS[100];
case 'arrendadorBuscaViajes':
return this.END_POINTS[101];
case 'clientRequestsShootingStarsTrip':
return this.END_POINTS[102];
case 'getShootingStarsOrders':
return this.END_POINTS[103];
case 'openPayDeposit':
return this.END_POINTS[104];
case 'openPayPayout':
return this.END_POINTS[105];
case 'HubbleToHubbleTransfer':
return this.END_POINTS[106];
case 'SMSCodeVerification':
return this.END_POINTS[107];
case 'ModifyPhoneNumber':
return this.END_POINTS[108];
case 'EliminarCuenta':
return this.END_POINTS[109];
case 'reviewAndRateShootingStarsTrip':
return this.END_POINTS[110];
case 'sendPragmaticCorporateMail':
return this.END_POINTS[111];
case 'VehicleCoordinates':
return this.END_POINTS[112];
case 'YourArtificialVoices':
return this.END_POINTS[113];
case 'Register_with_BBVA_account':
return this.END_POINTS[114];
case 'AuthSMSCodeVerification':
return this.END_POINTS[115];
case 'create_BBVA_ACCOUNT':
return this.END_POINTS[116];
case 'bindPhysicalCardToBBVA_account':
return this.END_POINTS[117];
case 'certifyMercado':
return this.END_POINTS[118];
case 'fetchBBVA_account_data':
return this.END_POINTS[119];
case 'requestMortgage':
return this.END_POINTS[120];
case 'requestAutomobileLoan':
return this.END_POINTS[121];
case 'requestBBVA_ATM_or_branches_locations':
return this.END_POINTS[122];
case 'PostingEntrelazamientoContent':
return this.END_POINTS[123];
case 'EntanglementInteraction':
return this.END_POINTS[124];
case 'createAWSTranscribe':
return this.END_POINTS[125];
case 'ProtoInternetData':
return this.END_POINTS[126];
case 'Historic_calls':
return this.END_POINTS[127];
case 'getHistoric_AI_CHAT':
return this.END_POINTS[128];
case 'redirectToInstagramForThirdPartyEntanglement':
return this.END_POINTS[129];
case 'postToInstagram':
return this.END_POINTS[130];
case 'redirectToXForPostsEntanglement':
return this.END_POINTS[131];
case 'handleUserIDInstagramCallback':
return this.END_POINTS[132];
case 'getting_TP_POSTS':
return this.END_POINTS[133];
case 'uploadThirdPartyMedia':
return this.END_POINTS[134];
case 'redirectToLinkedInForEntanglement':
return this.END_POINTS[135];
case 'redirectToTikTokForEntanglement':
return this.END_POINTS[136];
case 'redirectToYoutubeEntanglement':
return this.END_POINTS[137];
case 'postMediaToLinkedIn':
return this.END_POINTS[138];
case 'postMediaToX':
return this.END_POINTS[139];
case 'checkTikTokPostStatus':
return this.END_POINTS[140];
case 'getAuthTikTokProfile':
return this.END_POINTS[141];
case 'getAuthInstagramProfile':
return this.END_POINTS[142];
case 'getAuthLinkedInProfile':
return this.END_POINTS[143];
case 'getAuthXProfile':
return this.END_POINTS[144];
case 'postToTikTok':
return this.END_POINTS[145];
case 'get_BBVA_Locations':
return this.END_POINTS[146];
case 'getProfileByUser_Id':
return this.END_POINTS[147];
case 'getTTSAIAvatar':
return this.END_POINTS[148];
case 'getAuthWixProfile':
return this.END_POINTS[149];
case 'postUserObservations':
return this.END_POINTS[150];
case 'save_content_preferences_component':
return this.END_POINTS[151];
case 'graphUser':
return this.END_POINTS[152];
case 'getConversationTagsForAuthenticatedUser':
return this.END_POINTS[153];
case 'toggleConversationTags':
return this.END_POINTS[154];
case 'get_stories_by_user':
return this.END_POINTS[155];
case 'voice_note_instance':
return this.END_POINTS[156];
case 'enterToWalletWithPIN':
return this.END_POINTS[157];
case 'getAuthYouTubeToken':
return this.END_POINTS[158];
case 'VerificationWithOpenPay':
return this.END_POINTS[159];
case 'playlist_controller':
return this.END_POINTS[160];
case 'publications_from_playlist':
return this.END_POINTS[161];
case 'handle_hey_Lia':
return this.END_POINTS[162];
case 'insert_face_identifaction':
return this.END_POINTS[163];
case 'handleShippingWithAmazon':
return this.END_POINTS[164];
case 'requestAnUberRide':
return this.END_POINTS[165];
case 'handleShipping':
return this.END_POINTS[166];
case 'get_face_identifaction':
return this.END_POINTS[167];
case 'redirectToAmazonLoginForShipping':
return this.END_POINTS[168];
case 'createWireTransfer':
return this.END_POINTS[169];
case 'smsMesagesHandler':
return this.END_POINTS[170];
case 'WhatsappMesagesHandler':
return this.END_POINTS[171];
case 'postToThreadsProfile':
return this.END_POINTS[172];
case 'redirectToThreadsLoginForEntanglement':
return this.END_POINTS[173];
case 'redirectToThreadsLoginForGettingThreads':
return this.END_POINTS[174];
case 'profile_facade_sections_controller':
return this.END_POINTS[175];
case 'ShippingAddressesController':
return this.END_POINTS[176];
case 'getTextAutocomplePredictionGenerativePretrainingTransformer':
return this.END_POINTS[177];
case 'getAlibabaProducts':
return this.END_POINTS[178];
case 'AlibabaProductHandler':
return this.END_POINTS[179];		
case 'ControladorDeCarritoDeCompras':
return this.END_POINTS[180];		
case 'GetAuthUser':
return this.END_POINTS[181];																							
case 'PersistentLiveStreamIPTVController':
return this.END_POINTS[182];	
case 'UnAuthStripe':
return this.END_POINTS[183];																					
case 'getRecordByToken':
return this.END_POINTS[184];	
case 'sendPragmaticCorporateMailUnAuth':
return this.END_POINTS[185];	
case 'crypto_pal_unauth':
return this.END_POINTS[186];	
case 'openPayDeposit_unauth':
return this.END_POINTS[187];	
case 'getCurrencyValue_unauth':
return this.END_POINTS[188];	
case 'getLatestIOS_version':
return this.END_POINTS[189];	
case 'creatApplePayIntent':
return this.END_POINTS[190];	
case 'redirectToUberEntanglement':
return this.END_POINTS[191];	
case 'add_products_to_wishlist':
return this.END_POINTS[192];	
case 'sendFirebaseCM':
return this.END_POINTS[193];	
case 'requestCentralizedFreightUnAuth':
return this.END_POINTS[194];	
case 'make_a_guesty_request':
return this.END_POINTS[195];	
case 'SumMexicoKYC_url':
return this.END_POINTS[196];
case 'tmFetchEvents':
return this.END_POINTS[197];
case 'walmartAffiliateSearchDemo':
return this.END_POINTS[198];
case 'Auth_Stripe_Alibaba':
return this.END_POINTS[199];
case 'save_card_for_stripe_payment':
return this.END_POINTS[200];
case 'get_stripe_default_saved_payment_method':
return this.END_POINTS[201];
case 'chargeSavedStripeCard':
return this.END_POINTS[202];
case 'AliPayChargeSavedStripeCard':
return this.END_POINTS[203];
case 'spotify_search':
return this.END_POINTS[204];
case 'spotify_search_auth':
return this.END_POINTS[205];
case 'get_ds_margin_param':
return this.END_POINTS[206];
case 'search_page_unauth':
return this.END_POINTS[207];
case 'issue_individual_debit_card':
return this.END_POINTS[208];
case 'converse_bedrock':
return this.END_POINTS[209];
case 'createChatRequest_unauth':
return this.END_POINTS[210];
case 'get_video_gen_stat':
return this.END_POINTS[211];
case 'updateChatRequest_unauth':
return this.END_POINTS[212];
case 'get_AI_Videos_and_images':
return this.END_POINTS[213];
case 'make_a_bbva_api_channel_business_payment':
return this.END_POINTS[214];
case 'make_a_bbva_api_channel_business_payment_unauth':
return this.END_POINTS[215];
case 'get_saved_accounts':
return this.END_POINTS[216];
case 'update_sumamexico_veridocid_auth':
return this.END_POINTS[217];
case 'YourArtificialVoicesPublic':
return this.END_POINTS[218];
case 'agent-access-requests':
return this.END_POINTS[219];
case 'get_my_authenticated_mcps':
return this.END_POINTS[220];
case 'authorized-agents':
return this.END_POINTS[221];
case 'createOxxoIntent':
return this.END_POINTS[222];
case 'confirmAlibabaApplePay':
return this.END_POINTS[223];
case 'postMediaToFacebook':
return this.END_POINTS[224];
case 'getAuthFacebookProfile':
return this.END_POINTS[225];
case 'welcomeKycAutosave':
return this.END_POINTS[226];
case 'redirectToFacebookForPostsEntanglement':
return this.END_POINTS[227];
case 'loyalty-cards':
return this.END_POINTS[228];
case 'publications_AI_auth':
return this.END_POINTS[229];
case 'publications/seen':
return this.END_POINTS[230];
case 'apple-tv/pairing-sessions':
return this.END_POINTS[231];
case 'video-enhancements':
return this.END_POINTS[232];
case 'contacts/matches':
return this.END_POINTS[233];
case 'openpay-payouts':
return this.END_POINTS[234];
case 'profile_music_playlist':
return this.END_POINTS[235];
case 'profile_music_playlist_auth':
return this.END_POINTS[236];
case 'profile-games':
return this.END_POINTS[237];
case 'profiles':
return this.END_POINTS[238];
case 'welcomeFoundingFriends':
return this.END_POINTS[239];
case 'welcomeSubscription':
return this.END_POINTS[240];
case 'passkeys/authentication/options':
return this.END_POINTS[241];
case 'passkeys/authentication/verify':
return this.END_POINTS[242];
case 'passkeys/registration/options':
return this.END_POINTS[243];
case 'passkeys/registration/verify':
return this.END_POINTS[244];
case 'auth/account-lookup':
return this.END_POINTS[245];
case 'lia-collabs':
return this.END_POINTS[246];
case 'admin/featured-profile-photos':
return this.END_POINTS[247];
case 'wix/laniakea/jarvis/publish':
return this.END_POINTS[249];
case 'shazam/history':
return this.END_POINTS[250];
case 'shazam/token':
return this.END_POINTS[251];
case 'weather/context':
return this.END_POINTS[252];
case 'hubble/nearby/sessions':
return this.END_POINTS[253];
case 'hubble/nearby/resolve':
return this.END_POINTS[254];
case 'stripe/terminal/config':
return this.END_POINTS[255];
case 'stripe/terminal/feex-payment-intent':
return this.END_POINTS[256];
case 'stripe/terminal/confirm-feex-payment':
return this.END_POINTS[257];
case 'stripe/terminal/receipt':
return this.END_POINTS[258];
case 'mycelium/feed':
return this.END_POINTS[259];
case 'mycelium/text-posts':
return this.END_POINTS[260];
case 'mycelium/feed/auth':
return this.END_POINTS[261];
case 'mycelium/comments/view':
return this.END_POINTS[262];
case 'mycelium/comments/repost':
return this.END_POINTS[263];
case 'mycelium/comments/save':
return this.END_POINTS[264];
case 'mycelium/comments/saved':
return this.END_POINTS[265];
case 'mycelium/comments/reposted':
return this.END_POINTS[266];
case 'mycelium/comments/seen':
return this.END_POINTS[267];
case 'EmailCodeVerification':
return this.END_POINTS[268];
case 'mycelium/jarvis/mention':
return this.END_POINTS[269];
case 'wan-animations':
return this.END_POINTS[270];
case 'admin/jarvis-email-threads':
return this.END_POINTS[271];
case 'getOpenPaySubscriptionByUser':
return this.END_POINTS[272];
case 'jubilados-bbva/cases':
return this.END_POINTS[273];
case 'publications/not-interested':
return this.END_POINTS[274];
case 'jubilados-bbva/register':
return this.END_POINTS[275];
case 'iosCall':
return this.END_POINTS[276];
case 'call-invitations':
return this.END_POINTS[277];
case 'scheduled-calls':
return this.END_POINTS[278];






  

	  

	  
	

	


			default:
				break;
		}

		// Compatibility fallback only; new endpoints must still be appended to
		// BOTH END_POINTS and the ordered switch above with the correct index.
		const found = this.END_POINTS.find((entry: any[]) => entry[0] === endPoint);
		if (found) {
			return found;
		}

		return null
	}

	private createHeaders(endPoint: string): Promise<any> {
		if (endPoint === 'jubilados-bbva/cases') {
			return Promise.resolve({ Accept: 'application/json' });
		}
		return new Promise((resolve, reject) => {
			
			let endPointArray = this.selectEnpoint(endPoint);

			// Defensive guard: selectEnpoint can return null for dynamic paths like
			// "agent-access-requests/123/approve" if not called with the proper base+secondEndPoint pattern.
			if (!endPointArray) {
				console.warn(`[RequestService] Unknown endpoint for headers: ${endPoint}. Treating as public (no auth).`);
				resolve(this.HEADERS);
				return;
			}

			if (endPointArray[1] == '1') {
				if (this.expired_session) {
					console.log('Session expired');
					reject(new Error('Session expired'));
					return;
				}
				this.utils.getAccessData().then((AccessUserData: AccessUserData) => {
				
					this.HEADERS.Authorization = AccessUserData.getAuthorization();
					
					resolve(this.HEADERS);
				}).catch((error) => {
					reject(error);
				});
			} else {
				resolve(this.HEADERS);
			}

		});
	}

	private parseObjectToQueryParams(queryParams: any): string {
		let queryParamsBuild = "";
		if (queryParams) {
			Object.keys(queryParams).forEach((key, index) => {
				if (index == 0) {
					queryParamsBuild = "?"
				} else {
					queryParamsBuild += "&"
				}
				queryParamsBuild += key + "=" + queryParams[key];
			});
			return queryParamsBuild;
		}
		return queryParamsBuild;
	}

	private normalizeEndpointUrl(endPointBody: string): string {
		return endPointBody.replace(
			/(https?:\/\/)(supcluser|supercluser|supercluster)-api\.laniakea\.tv/gi,
			'$1supercluster-api.laniakea.tv'
		);
	}

	private createEndpoint(endPoint: string, params?: any, secondEndPoint?: string, queryParams?: any): Promise<string> {
    console.log('endpoint' , endPoint);
    console.log('params', params);
    console.log('second endpoin', secondEndPoint);
    console.log('query params', queryParams);
		return new Promise((resolve) => {
			let endPointBody;
			if (secondEndPoint) {
				if ((params["id2"]) != undefined) {
					endPointBody = (this.AUTH_SERVER_ADDRESS + this.selectEnpoint(endPoint)[0] + '/' + params["id"] + '/' + secondEndPoint + '/' + params["id2"]) + this.parseObjectToQueryParams(queryParams);
				}
					else {
						endPointBody = (this.AUTH_SERVER_ADDRESS + this.selectEnpoint(endPoint)[0] + '/' + params["id"] + '/' + secondEndPoint) + this.parseObjectToQueryParams(queryParams);
					}
					resolve(this.normalizeEndpointUrl(endPointBody));
				}
				else if (params) {
					if (params["id"]) {
	          endPointBody = (this.AUTH_SERVER_ADDRESS + this.selectEnpoint(endPoint)[0] + '/' + params["id"] + this.parseObjectToQueryParams(queryParams));
        }
					else {
						endPointBody = (this.AUTH_SERVER_ADDRESS + this.selectEnpoint(endPoint)[0] + '/' + '0' + this.parseObjectToQueryParams(queryParams));
					}
					resolve(this.normalizeEndpointUrl(endPointBody));
				}
				else {
					endPointBody = (this.AUTH_SERVER_ADDRESS + this.selectEnpoint(endPoint)[0] + this.parseObjectToQueryParams(queryParams));
					resolve(this.normalizeEndpointUrl(endPointBody));
				}
			});
		}

	private getShortCacheKey(method: 'GET' | 'POST', endPoint: string, url: string, body?: any): string {
		return JSON.stringify({
			method,
			endPoint,
			url,
			body: body || null,
		});
	}

	private readShortCache(key: string): any | undefined {
		const entry = this.shortCache.get(key);
		if (!entry) {
			return undefined;
		}

		if (entry.expiresAt <= Date.now()) {
			this.shortCache.delete(key);
			return undefined;
		}

		return entry.value;
	}

	private writeShortCache(key: string, value: any): void {
		this.shortCache.set(key, {
			expiresAt: Date.now() + this.shortCacheMs,
			value,
		});
	}

	private shouldShortCache(method: 'GET' | 'POST', endPoint: string, object?: any): boolean {
		if (method === 'GET') {
			return this.cacheableGetEndpoints.has(endPoint);
		}

		if (!this.cacheablePostEndpoints.has(endPoint)) {
			return false;
		}

		if (object && typeof object === 'object') {
			const writeFlags = ['add_items', 'update_cart', 'delete_items', 'post', 'store', 'create', 'save', 'notify'];
			if (writeFlags.some((flag) => object[flag])) {
				return false;
			}
		}

		return true;
	}

	/** Keep request diagnostics useful without ever dumping image/audio payloads. */
	private summarizeRequestPayload(payload: any): any {
		if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return payload;
		const sensitiveKeys = new Set(['base64', 'BASE64', 'image_base64', 'imageData', 'dataUrl', 'data_url']);
		return Object.keys(payload).reduce((summary: Record<string, any>, key) => {
			const value = payload[key];
			if (sensitiveKeys.has(key)) {
				summary[key] = {
					present: typeof value === 'string' && value.length > 0,
					chars: typeof value === 'string' ? value.length : 0,
				};
			} else if (Array.isArray(value)) {
				summary[key] = `[array:${value.length}]`;
			} else if (typeof value === 'string' && value.length > 500) {
				summary[key] = `${value.slice(0, 500)}…`;
			} else {
				summary[key] = value;
			}
			return summary;
		}, {});
	}

	/** Ensures every remote push contains a safe, useful universal-link target. */
	private withNotificationUniversalLink(notification: any): any {
		if (!notification || typeof notification !== 'object' || Array.isArray(notification)) {
			return notification;
		}

		const payload = { ...notification };
		if (payload.meeting_id) {
			payload.universal_link = `https://laniakea.tv/calls/incoming?meeting_id=${encodeURIComponent(String(payload.meeting_id))}`;
			return payload;
		}
		const existingLink = payload.universal_link || payload.link || payload.deep_link;
		if (typeof existingLink === 'string' && existingLink.trim()) return payload;

		const conversationId = String(payload.conversation_id || payload.chat_id || '').trim();
		if (/^[A-Za-z0-9-]{1,128}$/.test(conversationId)) {
			payload.universal_link = `https://laniakea.tv/home/chat-page/${encodeURIComponent(conversationId)}`;
			return payload;
		}

		const publicationId = Number(payload.publication_id || payload.post_id || payload.post || 0);
		if (Number.isSafeInteger(publicationId) && publicationId > 0) {
			payload.universal_link = `https://laniakea.tv/p/${publicationId}`;
			return payload;
		}

		payload.universal_link = 'https://laniakea.tv/notifications-page';
		return payload;
	}

	public createRequestPost(endPoint: string, object?: any, params?: any, secondEndPoint?: string, queryParams?: any): Promise<any> {
		const requestObject = endPoint === 'GreatAtractorNotifications'
			? this.withNotificationUniversalLink(object)
			: object;
		if (Capacitor.getPlatform() !== 'web'){
		return new Promise((resolve, reject) => {
			this.createHeaders(endPoint).then((headers) => {
				this.http.setDataSerializer('json');
        console.log('llega aqui', endPoint);
        console.log('llega aqui params', params);
				this.createEndpoint(endPoint, params, secondEndPoint, queryParams).then((endPointBody: string) => {
          if (endPoint === 'publications.multimedia') {
            if(requestObject['publication_id']){
              endPointBody = endPointBody + '/'+ requestObject.publication_id;
            }
          }else if(endPoint == 'profile/multimedia'){
            if(requestObject['profile_id'] ){
              endPointBody = endPointBody.replace('profile/multimedia','profile/'+requestObject['profile_id']+'/multimedia');
            }
          }else if(endPoint == 'comments.multimedia') {
            if (requestObject['comment_id']) {
              endPointBody = endPointBody +'/' + requestObject.comment_id;
            }
          }
					console.log("endpointBody", endPointBody);
          console.log("body", requestObject);
					const cacheKey = this.shouldShortCache('POST', endPoint, requestObject)
						? this.getShortCacheKey('POST', endPoint, endPointBody, requestObject)
						: '';
					const cachedResponse = cacheKey ? this.readShortCache(cacheKey) : undefined;
					if (cachedResponse !== undefined) {
						resolve(cachedResponse);
						return;
					}

					this.http.post(endPointBody, requestObject, headers).then((data) => {
						if (cacheKey) {
							this.writeShortCache(cacheKey, data.data);
						}
						resolve(data.data);
					}).catch((error) => {
						this.handleMaintenanceMode(error);
						console.error(error);
						this.utils.checkErrors(error).then((requestResponse) => {
							//this.utils.alertPresent('Errors', requestResponse, 'OK');
							reject(error);
						}).catch((error) => {
							reject(error);
						});
					});
				}).catch((error) => {
					console.error(error)
					reject(error);
				});
			}).catch((error) => {
				console.error(error);

				reject(error);
			});
		});
	}else {
		return this.createWebRequestPost(endPoint, requestObject, params, secondEndPoint, queryParams);
	}
	}

	public createRequestPostMultipart(endPoint: string, formData: FormData): Promise<any> {
		return new Promise((resolve, reject) => {
			this.createHeaders(endPoint).then((headers: any) => {
				this.createEndpoint(endPoint, null, undefined, undefined).then((url: string) => {
					const multipartHeaders: any = { ...headers };
					delete multipartHeaders['Content-Type'];
					fetch(url, { method: 'POST', headers: multipartHeaders, body: formData })
						.then(async response => {
							const body = await response.text();
							let data: any = body;
							try { data = body ? JSON.parse(body) : body; } catch {}
							if (!response.ok) {
								const error: any = new Error(`Network response was not ok: ${response.status}`);
								error.status = response.status;
								error.error = data;
								throw error;
							}
							resolve(data);
						})
						.catch(reject);
				}).catch(reject);
			}).catch(reject);
			});
		}
	public createWebRequestPost(endPoint: string, object?: any, params?: any, secondEndPoint?: string, queryParams?: any): Promise<any> {
		return new Promise((resolve, reject) => {
		  this.createHeaders(endPoint).then((headers) => {
			this.createEndpoint(endPoint, params, secondEndPoint, queryParams).then((endPointBody: string) => {
			  if (endPoint === 'publications.multimedia') {
				if (object?.publication_id) {
				  endPointBody = endPointBody + '/' + object.publication_id;
				}
			  } else if (endPoint === 'profile/multimedia') {
				if (object?.profile_id) {
				  endPointBody = endPointBody.replace('profile/multimedia', 'profile/' + object.profile_id + '/multimedia');
				}
			  } else if (endPoint === 'comments.multimedia') {
				if (object?.comment_id) {
				  endPointBody = endPointBody + '/' + object.comment_id;
				}
			  }
	  
			  console.log("endpointBody", endPointBody);
			  console.debug("[request] POST payload", this.summarizeRequestPayload(object));
			  const cacheKey = this.shouldShortCache('POST', endPoint, object)
				? this.getShortCacheKey('POST', endPoint, endPointBody, object)
				: '';
			  const cachedResponse = cacheKey ? this.readShortCache(cacheKey) : undefined;
			  if (cachedResponse !== undefined) {
				resolve(cachedResponse);
				return;
			  }
	  
			  const requestOptions: RequestInit = {
				method: 'POST',
				headers: headers,
				body: JSON.stringify(object)
			  };
	  
				fetch(endPointBody, requestOptions)
				.then(async response => {
					if (!response.ok) {
						const responseText = await response.text();
						let responseError: any = responseText;
						try {
							responseError = responseText ? JSON.parse(responseText) : responseText;
						} catch {}
						const requestError: any = new Error(`Network response was not ok: ${response.status} - ${response.statusText}`);
						requestError.status = response.status;
						requestError.statusText = response.statusText;
						requestError.error = responseError;
						throw requestError;
					}
					return response.json();
				})
				.then(data => {
					if (cacheKey) {
						this.writeShortCache(cacheKey, data);
					}
					resolve(data);
				})
				.catch(error => {
				  this.handleMaintenanceMode(error);
				  console.error('[request] POST failed', {
					endpoint: endPoint,
					url: endPointBody,
					status: error?.status || 'unknown',
					message: error?.message || String(error),
					error: error?.error,
				  });
				  this.utils.checkErrors(error)
					.then(requestResponse => {
					  //this.utils.alertPresent('Errors', requestResponse, 'OK');
					  reject(error);
					})
					.catch(error => reject(error));
				});
			}).catch((error) => {
			  console.error(error);
			  reject(error);
			});
		  }).catch((error) => {
			console.error(error);
			reject(error);
		  });
		});
	  }

	public createWebRequestDelete(endPoint: string, object?: any, params?: any, secondEndPoint?: string, queryParams?: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.createHeaders(endPoint).then((headers) => {
				this.createEndpoint(endPoint, params, secondEndPoint, queryParams).then((endPointBody: string) => {
					console.log('delete endpoint', endPoint);
					console.log('delete endpointbody', endPointBody);

					const requestOptions: RequestInit = {
						method: 'DELETE',
						headers: headers,
						body: object ? JSON.stringify(object) : undefined
					};

					fetch(endPointBody, requestOptions)
						.then(async response => {
							if (!response.ok) {
								const text = await response.text().catch(() => '');
								throw new Error(`Network response was not ok: ${response.status} - ${response.statusText} ${text}`);
							}
							// DELETE often returns 204 No Content
							const text = await response.text().catch(() => '');
							if (!text) return {};
							try {
								return JSON.parse(text);
							} catch {
								return text;
							}
						})
						.then(data => resolve(data))
						.catch(error => {
							this.handleMaintenanceMode(error);
							this.utils.checkErrors(error).then((requestResponse) => {
								this.utils.alertPresent('Errors', requestResponse, 'OK');
								reject(error);
							}).catch((error) => {
								reject(error);
							});
						});
				}).catch((error) => {
					reject(error);
				});
			}).catch((error) => {
				reject(error);
			});
		});
	}

  public createRequestGet(endPoint: string, queryParams?: any, params?: any, secondEndPoint?: string): Promise<any> {
	// The native cordova-plugin-advanced-http bridge rejects these inbox
	// responses on iOS, so use WKWebView fetch across platforms.
	if (endPoint === 'jubilados-bbva/cases') {
		return this.createWebRequestGet(endPoint, queryParams, params, secondEndPoint)
			.catch((error) => {
				if (!/\b404\b/.test(String(error?.status ?? error))) throw error;
				return this.createLegacyPublicJubiladosGet(queryParams);
			});
	}
	if (endPoint === 'admin/jarvis-email-threads') {
		return this.createWebRequestGet(endPoint, queryParams, params, secondEndPoint);
	}
	if (Capacitor.getPlatform() !== 'web'){
  return new Promise((resolve, reject) => {
			this.createHeaders(endPoint).then((headers) => {
				this.http.setDataSerializer('json');
				// The native Cordova HTTP bridge can drop GET parameters for this
				// endpoint. Encode WeatherKit coordinates in the URL itself.
				const inlineWeatherQuery = endPoint === 'weather/context' ? queryParams : undefined;
				this.createEndpoint(endPoint, params, secondEndPoint, inlineWeatherQuery).then((endPointBody: string) => {
          console.log('endpointbody', endPointBody);
					const cacheKey = this.shouldShortCache('GET', endPoint)
						? this.getShortCacheKey('GET', endPoint, endPointBody, queryParams)
						: '';
					const cachedResponse = cacheKey ? this.readShortCache(cacheKey) : undefined;
					if (cachedResponse !== undefined) {
						resolve(cachedResponse);
						return;
					}
					this.http.get(endPointBody, inlineWeatherQuery ? {} : queryParams, headers).then((data) => {
            // console.log("params",params);
            // console.log("Data",data.data);

						if (cacheKey) {
							this.writeShortCache(cacheKey, data.data);
						}
						resolve(data.data);
					}).catch((error) => {
						this.handleMaintenanceMode(error);
						if (error.status === 419) {
                            console.log('Response status is 419');
                            this.showUnauthenticatedAlert(); // Handle 419 with SwalAlert
                            console.log('showUnauthenticatedAlert() called');
                        }
						this.utils.checkErrors(error).then((requestResponse) => {
							//this.utils.alertPresent('Errors', requestResponse, 'OK');
							reject(error);
						}).catch((error) => {
							reject(error);
						});
					
					});
				}).catch((error) => {
					reject(error);
				});
			}).catch((error) => {
				reject(error);
			});
		});
	}else {
			return this.createWebRequestGet(endPoint, queryParams, params, secondEndPoint);
		}
	}

	private async createLegacyPublicJubiladosGet(queryParams?: any): Promise<string> {
		const url = new URL(this.AUTH_SERVER_ADDRESS + 'admin/jarvis-email-threads');
		url.searchParams.set('jubilados', '1');
		Object.entries(queryParams || {}).forEach(([key, value]) => {
			if (value !== undefined && value !== null) url.searchParams.set(key, String(value));
		});
		const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
		if (!response.ok) throw new Error(`Legacy expediente request failed: ${response.status}`);
		return response.text();
	}
	public createWebRequestGet(endPoint: string, queryParams?: any, params?: any, secondEndPoint?: string): Promise<any> {
		return new Promise((resolve, reject) => {
		  this.createHeaders(endPoint).then((headers) => {
			this.createEndpoint(endPoint, params, secondEndPoint).then((endPointBody: string) => {
			  console.log('endpointbody', endPointBody);
	  
			  const requestOptions: RequestInit = {
				method: 'GET',
				headers: headers
			  };
	  
			  let url = new URL(endPointBody);
			  if (queryParams) {
				Object.keys(queryParams).forEach(key => {
				  url.searchParams.append(key, queryParams[key]);
				});
			  }
			  const cacheKey = this.shouldShortCache('GET', endPoint)
				? this.getShortCacheKey('GET', endPoint, url.toString())
				: '';
			  const cachedResponse = cacheKey ? this.readShortCache(cacheKey) : undefined;
			  if (cachedResponse !== undefined) {
				resolve(cachedResponse);
				return;
			  }
	  
			  fetch(url.toString(), requestOptions)
				.then(response => {
				  if (!response.ok) {
					if (response.status === 419) {
						console.log('Response status is 419');
						this.showUnauthenticatedAlert(); // Handle 419 with SwalAlert
						console.log('showUnauthenticatedAlert() called');
					}
					throw new Error(`Network response was not ok: ${response.status} - ${response.statusText}`);

				  }
				  return response.text(); // Use response.text() for non-JSON responses
				})
				.then(data => {
					if (cacheKey) {
						this.writeShortCache(cacheKey, data);
					}
					resolve(data);
				}) // Resolve with the raw data
				.catch(error => {
					this.handleMaintenanceMode(error);
					this.utils.checkErrors(error).then((requestResponse) => {
						//this.utils.alertPresent('Errors', requestResponse, 'OK');
						reject(error);
					}).catch((error) => {
						reject(error);
					});

				
				});
			}).catch((error) => {
			  reject(error);
			});
		  }).catch((error) => {
			reject(error);
		  });
		});
	  }
	  
	  
	public createRequestPut(endPoint: string, object?: any, params?: any, secondEndPoint?: string, queryParams?: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.createHeaders(endPoint).then((headers) => {
				this.http.setDataSerializer('json');
				this.createEndpoint(endPoint, params, secondEndPoint, queryParams).then((endPointBody: string) => {
					this.http.put(endPointBody, object, headers).then((data) => {
						resolve(data.data);
					}).catch((error) => {
						this.handleMaintenanceMode(error);
						this.utils.checkErrors(error).then((requestResponse) => {
							this.utils.alertPresent('Errors', requestResponse, 'OK');
							reject(error);
						}).catch((error) => {
							reject(error);
						});
					});
				}).catch((error) => {
					reject(error);
				});
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public createRequestDelete(endPoint: string, object?: any, params?: any, secondEndPoint?: string, queryParams?: any): Promise<any> {
		if (Capacitor.getPlatform() !== 'web') {
			return new Promise((resolve, reject) => {
				this.createHeaders(endPoint).then((headers) => {
					this.http.setDataSerializer('json');
					this.createEndpoint(endPoint, params, secondEndPoint, queryParams).then((endPointBody) => {
						console.log('delete endpoint', endPoint);
						console.log('delete endpointbody', endPointBody);
						this.http.delete(endPointBody, (object != null) ? object.queryParams : undefined, headers).then((data) => {
							resolve(data.data);
						}).catch((error) => {
							this.handleMaintenanceMode(error);
							this.utils.checkErrors(error).then((requestResponse: RequestResponse) => {
								this.utils.alertPresent('Errors', requestResponse, 'OK');
								reject(error);
							}).catch((error) => {
								reject(error);
							});
						});
					}).catch((error) => {
						reject(error);
					});
				}).catch((error) => {
					reject(error);
				});
			});
		} else {
			return this.createWebRequestDelete(endPoint, object, params, secondEndPoint, queryParams);
		}
	}
	expired_session;
	private showUnauthenticatedAlert() {
		if (this.expired_session) {
			console.log('expired_session')
			return;

		  }
		
		  this.expired_session = true;
		  setTimeout(() => {
		Swal2.fire({
			title: 'No autenticado',
			text: 'The session is not active. Please sign in.',
			icon: 'warning',
			showCancelButton: true,
			cancelButtonText:'Cancel',
			confirmButtonColor: 'green',
			color: '#ffffff',
			background: '#010f4e',
			position: 'top-end',
			timerProgressBar: true,
			toast: true,
			confirmButtonText: 'OK'
		}).then((result) => {
			if (result.isConfirmed) {
				// Handle logout process here
				//this.logout_button();
				this.router.navigate(['/login']);
			}
		});
	}, 45000);
	}

	private handleMaintenanceMode(error: any) {
		return;
	}
		/*
	logout_button() {
	
		this.utils.loadingPresent().then(() => {
			this.authService.logout().finally(() => {
				this.chatService.logoutSuscribers();
				this.nativeStorage.clear(); // Just clear native storage
				this.utils.loadingDismiss();
				this.navCtrl.navigateRoot('starting-page');
				window.location.reload();
			});
		});
	}*/
	
}
